import generateQrStatis from "./generate-qr";
import outletManagement from "./outlet-management";
import mappingQrisTap from "./mapping-qristap";

export default {
  generateQrStatis,
  outletManagement,
  mappingQrisTap,
};